import { render } from "./YeniDugme.vue?vue&type=template&id=88dfe0a8"
import script from "./YeniDugme.vue?vue&type=script&lang=js"
export * from "./YeniDugme.vue?vue&type=script&lang=js"

import "./YeniDugme.vue?vue&type=style&index=0&id=88dfe0a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__